export default __webpack_public_path__ + "static/media/Orange_Stars-Health-Report.c01c6ab4.pdf";